import { getSafeArea } from "./safeAreaState";

var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, { get: (a, b) => (typeof require !== "undefined" ? require : a)[b] }) : x)(function(x) {
	if (typeof require !== "undefined") return require.apply(this, arguments);
	throw Error("Calling `require` for \"" + x + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
});

function setup() {
	var g = globalThis;
	if (g.__tamagui_native_safe_area_setup_complete) return;
	g.__tamagui_native_safe_area_setup_complete = true;
	try {
		var { useSafeAreaInsets, useSafeAreaFrame, initialWindowMetrics } = require("react-native-safe-area-context");
		if (useSafeAreaInsets) getSafeArea().set({
			enabled: true,
			useSafeAreaInsets,
			useSafeAreaFrame: useSafeAreaFrame || null,
			initialMetrics: initialWindowMetrics || null
		});
	} catch (e) {}
}
setup();

